'use client';

import { useState, useEffect, useCallback } from 'react';

interface AuthUser {
  githubUsername: string;
  avatarUrl: string | null;
  country: string | null;
  email: string | null;
  isMoment?: boolean;
}

export function useAuth() {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/auth/me')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        const u = data?.user ?? null;
        setUser(u);
        if (typeof window !== 'undefined' && window.DD_RUM) {
          if (u) {
            window.DD_RUM.setUser({ name: u.githubUsername, email: u.email ?? undefined });
          } else {
            window.DD_RUM.clearUser();
          }
        }
      })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const logout = useCallback(async () => {
    await fetch('/api/auth/logout', { method: 'POST' });
    setUser(null);
    if (typeof window !== 'undefined' && window.DD_RUM) {
      window.DD_RUM.clearUser();
    }
  }, []);

  const updateUser = useCallback((updates: Partial<AuthUser>) => {
    setUser(prev => prev ? { ...prev, ...updates } : null);
  }, []);

  return { user, loading, logout, updateUser };
}
